import type { ImgHTMLAttributes } from "react";

import brandMarkUrl from "@secops/icons/svg/marks/mark-secops-v2.svg";

/**
 * Active SecOps mark (v2 shield + lock + silver orbit), served from @secops/icons so every
 * surface renders the one generated asset. The PWA manifest PNGs under public/icons/ are
 * separate, deliberately untouched assets.
 */
export const BRAND_MARK_SRC = brandMarkUrl;

type BrandMarkProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

/** SecOps brand mark, shared SVG asset so logo gradients stay intact. */
export function BrandMark({ className, ...props }: BrandMarkProps) {
  return (
    <img
      src={BRAND_MARK_SRC}
      alt=""
      className={className}
      aria-hidden="true"
      draggable={false}
      {...props}
    />
  );
}
